import React from "react";
import Skeleton from "react-loading-skeleton";

const SkeletonLoader = ({ type, count = 1, height, width, gap }) => {
  switch (type) {
    case "circle":
      return (
        <Skeleton circle={true} height={height || 50} width={width || 50} />
      );
    case "text":
      return <Skeleton count={count} />;
    case "heading":
      return <Skeleton height={height || 30} width={width || "80%"} />;
    case "paragraph":
      return (
        <div>
          {[...Array(count)].map((_, idx) => (
            <Skeleton
              key={idx}
              height={height || 20}
              style={{ marginBottom: gap }}
            />
          ))}
        </div>
      );
    case "card":
      return (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            padding: "16px",
            borderRadius: "8px",
            background: "#fff",
            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
            width: width || "300px",
            height: height || "200px",
            // marginBottom:"50px"
          }}
        >
          <Skeleton circle={true} height={50} width={50} />
          <Skeleton height={20} width="60%" style={{ marginTop: "10px" }} />
          <Skeleton height={15} width="80%" style={{ marginTop: "6px" }} />
          <Skeleton height={15} width="90%" style={{ marginTop: "6px" }} />
        </div>
      );
    default:
      return <Skeleton height={height || 50} width={100} />;
  }
};

export default SkeletonLoader;
